const scrapingTemplateScrapingIssueFormInitialValues = ({
  id,
  scrapingIssueComment,
}) => ({
  id,
  scrapingIssueComment,
})

export default scrapingTemplateScrapingIssueFormInitialValues
